import { PageContentAccount } from '@restaurant/core'
import { useWebAccountPageViewModel } from '../viewmodels/pages/WebAccountPageViewModel'

export default function AccountPage() {
  const viewModel = useWebAccountPageViewModel()

  // Use the ViewModel's built-in props getter which returns correctly formatted props
  const pageProps = viewModel.getPageContentAccountProps()

  return (
    <PageContentAccount
      {...pageProps}
      testID="account-page"
      accessibilityLabel="Account management page with user profile and settings"
    />
  )
}